export default __webpack_public_path__ + "static/media/warning--railroad-crossing-without-barriers--g3.0a195b24.png";